import { RiSmartphoneLine } from "react-icons/ri";
import { TbWorld } from "react-icons/tb";
import Button from "../components/Shared/Button/Button";
import {
  Checkbox,
  Dropdown,
  IconInput,
  Input,
} from "../components/Shared/Input/AuthInput";

const Register = () => {
  return (
    <div className="grid min-h-screen place-items-center bg-lightGray py-20">
      <div className="flex w-[716px] flex-col items-center justify-center rounded-[20px] bg-white">
        <picture className="mt-14 mb-8 h-28 w-52">
          <img src="/assets/images/logo.png" alt="" />
        </picture>
        <p className="mb-14 font-inter text-[32px] font-semibold text-black text-opacity-50">
          Create an Account
        </p>
        <div className="px-32">
          <Input placeholder="User Name" />
          <Input placeholder="Name" />
          <Input placeholder="Surname" />
          <Input placeholder="Email" />
          <Input placeholder="Confirm Email" />
          <IconInput placeholder="+92 Pakistan" Icon={TbWorld} />
          <IconInput placeholder="Phone" Icon={RiSmartphoneLine} />
          <Input placeholder="Password" password />
          <Input placeholder="Confrim Password" password />
          <Dropdown placeholder="Province" />
          <Dropdown placeholder="Town" />

          <Checkbox
            text={
              <p>
                I accept the <strong>Terms & Conditions</strong>
              </p>
            }
          />
          <Checkbox
            text={
              <p>
                I accept the <strong>Privacy Policy</strong>
              </p>
            }
          />
          <Checkbox
            text={
              <p>
                I am <strong>18 years of Age</strong> and understand all bids
                are legally binding and will honour all bids
              </p>
            }
          />
          <Button
            text="Register"
            variant="primary"
            className="mb-14 !w-full rounded-lg !py-3"
          />
        </div>
      </div>
    </div>
  );
};

export default Register;
